import React from 'react';
import { ChevronRight } from 'lucide-react';

export const QualQuestion = ({ step, value, en, onPick }) => (
  <div className="animate-fade-up" key={step.key} data-testid={`qual-step-${step.key}`}>
    <h3 className="font-bold text-gray-900 text-base mb-3">{en ? step.en : step.fr}</h3>
    <div className="space-y-2">
      {step.options.map(([fr, enL], i) => {
        const selected = value === fr;
        return (
          <button
            type="button"
            key={fr}
            onClick={() => onPick(fr)}
            className={`w-full flex items-center justify-between text-left px-4 py-3 rounded-xl border-2 text-sm font-semibold transition-[border-color,background-color,transform] duration-200 active:scale-[0.98] ${selected ? 'border-[#1a5c3b] bg-green-50 text-[#1a5c3b]' : 'border-slate-200 text-slate-700 hover:border-[#1a5c3b]/50 hover:bg-slate-50'}`}
            data-testid={`qual-${step.key}-option-${i}`}
          >
            {en ? enL : fr}
            <ChevronRight className={`w-4 h-4 ${selected ? 'text-[#1a5c3b]' : 'text-slate-300'}`} />
          </button>
        );
      })}
    </div>
  </div>
);
